import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import {
  FleetColumnData,
  ExtColumnData,
  ColumnsData,
} from '../models/api/column.model';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ColumnsService {
  private columnsUrl = environment.baseUrl +  environment.api + 'extcolumns'  + environment.surfix;

  constructor(private http: HttpClient, private authService: AuthService) {}

  getExtColumns() {
    return this.http.get<ExtColumnData[]>(this.columnsUrl + '/allpharmacy'  + environment.surfix, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  updateColumn(columnId, visible) {
    const headers = this.authService.getJwtAuthHeaders();

    return this.http.put(
      this.columnsUrl + '/' + columnId,
      {},
      {
        headers: headers,
        params: {
          visible: visible,
        },
      }
    );
  }

  getColumns() {
    return forkJoin([this.getFleetColumns(), this.getExtColumns()]).pipe(
      map((resp) => {
        const columns: ColumnsData = {
          fleetColumns: resp[0],
          extColumns: resp[1],
        };
        return columns;
      })
    );
  }

  getFleetColumns() {
    return this.http.get<FleetColumnData>(this.columnsUrl + '/fleet' + environment.surfix, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }

  updateFleetColumns(fleetColumns: FleetColumnData) {
    return this.http.put(this.columnsUrl + '/fleet/', fleetColumns, {
      headers: this.authService.getJwtAuthHeaders(),
    });
  }
}
